import * as React from "react";
import { filter } from "graphql-anywhere";
import { makeStyles } from "@mui/styles";
import { fragments as orderAppProductionJobListItemFragments } from "./OrderAppProductionJobListItem/graph";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import OrderAppProductionJobListItem from "./OrderAppProductionJobListItem";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  listItemWrapper: {
    marginBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.secondary.main}`,
    marginTop: theme.spacing(1),
    "&:last-child": {
      borderBottomStyle: "none"
    }
  },
  title: {
    marginBottom: theme.spacing(1)
  }
}));

const OrderAppProductionJobList = ({ order }) => {
  const classes = useStyles();

  return (
    <div>
      {order.productionJobs.length > 0 && (
        <React.Fragment>
          <Typography className={classes.title} variant="h6">
            Production Jobs
          </Typography>
          <Card>
            <CardContent>
              {order.productionJobs.map((productionJob, index) => (
                <div className={classes.listItemWrapper} key={productionJob.id}>
                  <OrderAppProductionJobListItem
                    index={`${index + 1}`}
                    productionJob={filter(
                      orderAppProductionJobListItemFragments.productionJob,
                      productionJob
                    )}
                    productionStationAssignments={filter(
                      orderAppProductionJobListItemFragments.productionStationAssignments,
                      order.productionStationAssignments
                    )}
                  />
                </div>
              ))}
            </CardContent>
          </Card>
        </React.Fragment>
      )}
    </div>
  );
};

export default OrderAppProductionJobList;
